import React from "react";
import { Carousel } from "react-bootstrap";
import "./Carocel.css";
const Carocel = () => {
  return (
    <div>
      <div>
        <img
          className="clas"
          src={
            "https://www.happywedding.app/blog/wp-content/uploads/2019/01/Photography-for-Indian-Weddings.jpg"
          }
          alt=""
        />
        <h1 className="mahesh">Mahesh's Photography</h1>
      </div>
    </div>
  );
};

export default Carocel;
